import { SelectProps } from '@mantine/core';
import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { useOrganization } from 'src/hooks/useOrganization';

export interface IChangeTemplateSelectorProps
  extends Omit<SelectProps, 'data'> {
  value: string | null;
  onChange: (value: string | null) => void;
}

/** @registry Select dropdown of change order templates, backed by the organization's cached template list. */
export const ChangeTemplateSelector: React.FC<IChangeTemplateSelectorProps> = ({
  value,
  onChange,
  label = 'Change Template',
  placeholder = 'Select a change template...',
  ...props
}) => {
  const { changeTemplates } = useOrganization();

  const templateOptions = React.useMemo(() => {
    return changeTemplates.map((template) => ({
      value: template.id,
      label: template.title,
    }));
  }, [changeTemplates]);

  return (
    <Select
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      data={templateOptions}
      clearable
      searchable
      {...props}
    />
  );
};
